document.addEventListener('DOMContentLoaded', function() {
    const searchTrigger = document.querySelector('[data-search-drawer-trigger]');
    const searchDrawer = document.querySelector('#Search-Drawer');
    
    if (searchTrigger && searchDrawer) {
      searchTrigger.addEventListener('click', function() {
        // Add active class to show drawer
        searchDrawer.classList.add('active');
        document.body.classList.add('side-panel-open');
        
        // Focus on search input when drawer opens
        setTimeout(() => {
          const searchInput = searchDrawer.querySelector('#side-panel-search-input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      });
    }
  });